import React, {useState} from 'react';
import UserReportForm from './ReportUser.js';
import "../css/profileForm.css";
import DeleteWarningForm from './deletewarning.js';
import {BASE_URL} from "../constants"
import { useLanguage } from "../components/Language.js";

function OtherProfileForm({ otherProfileData, user, onClose}) {

  const {language} = useLanguage();

  const translations = {
    en: {
      profileOwner: `${otherProfileData.first_name} ${otherProfileData.last_name}'s profile`,
      noBioProvided: "No bio provided",
      deleteProfile: "Delete Profile",
      close: "Close",
      report: "Report",
      addToNetwork: "Add To Network"
           
    },

    gd: {
      profileOwner: `Pròifil ${otherProfileData.first_name} ${otherProfileData.last_name}'s`,
      noBioProvided: "Chan eil eachdraidh-beatha air a thoirt",
      deleteProfile: "Dubh às Pròifil ",
      close: "Dùin",
      report: "Aithris",
      addToNetwork: "Cuir ris an lìonra",
        
    },
};

    const [isReportVisible, setIsReportVisible] = useState(false);
    const [isWarningVisible, setWarningVisible] = useState(false);

    const handleConfirmDelete = async (username) => {

        console.log("In handle confirm delete");
        
        const response = await fetch(`${BASE_URL}/api/delete_user/`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username }),
        });
    
        if (response.ok) {
          
          console.log(username, "has now been deleted");
          setWarningVisible(false);
          onClose();
        } 
    };

    const handleAddToNetwork = async (username, otherUsername) => {

      console.log("username: ", username, "otherUsername: ", otherUsername)

      const response = await fetch(`${BASE_URL}/api/add_to_network/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, other_username: otherUsername }),
      });

      const data = await response.json();
      alert(data.message);
      console.log(data)
  };

    

    const handleCancel = () => {
        setWarningVisible(false);
      };

    const handleDeleteProfileClick = () => {
        setWarningVisible(true);
      };

    const handleReportUser = async () => {
        setIsReportVisible(!isReportVisible);
        }

        // console.log("user: ", user.admin)


    return(
    <div>
        <h3 className="mt-3">{translations[language].profileOwner}</h3>
        <img 
          className="other-profile-image"
          src={otherProfileData.profile_picture}
          alt="profile picture"
        />

        {otherProfileData.about !== "Unknown" ?(
          <h3>{otherProfileData.about}</h3>

        ):(
          <h3>{translations[language].noBioProvided}</h3>
        )}

        <button id="network-button" onClick={() => handleAddToNetwork(user.username, otherProfileData.username)}>{translations[language].addToNetwork}</button>
        <button id="report-button" onClick={handleReportUser}>{translations[language].report}</button>
        <button id="close-profile-button" onClick={onClose}>{translations[language].close}</button>

        {user.admin && (
          <button
            id="delete-profile-button"
            onClick={() => handleDeleteProfileClick()}
          >
            {translations[language].deleteProfile}
          </button>
        )}



        {isReportVisible && (
            <div className="user-report-container active">
                <UserReportForm 
                    otherUser = {otherProfileData}
                    onClose= {() => setIsReportVisible(false)}
                />
            </div>
        )}

        {isWarningVisible && (
            <DeleteWarningForm
                deleteInfo={otherProfileData.username}
                onCancel={handleCancel}
                onConfirm={() => handleConfirmDelete(otherProfileData.username)}
            />
            )}
      </div>
    
    )}

export default OtherProfileForm;